export default __webpack_public_path__ + "static/media/image_3.75580be7.jpg";